import { persistUTMQueryParamsToString } from "@common/utils/router";
import {
  Button,
  Card,
  Flex,
  Text,
  Title,
  useMantineTheme,
} from "@mantine/core";
import Link from "next/link";
import { ReactElement } from "react";
import { INewPurchaseCardProps } from "./types";
import { useRouter } from "next/router";

export default function NewPurchaseCard({
  account,
  purchases,
}: INewPurchaseCardProps): ReactElement {
  const theme = useMantineTheme();

  const router = useRouter();

  const hasPurchases = !(!purchases || purchases.length === 0);

  return (
    <Card maw={theme.breakpoints.sm} p="xl" withBorder>
      <Flex align="flex-start" direction="column" justify="flex-start" w="100%">
        <Title mb={theme.spacing.xs / 2} order={2} size="h3">
          Let&apos;s get {hasPurchases ? "a new" : "your first"} instance set up
          {account?.first_name ? `, ${account?.first_name}` : ""}
        </Title>
        <Text fz="sm">
          Get everything you need to start exploring data in five minutes with a
          14-day free trial.
        </Text>
      </Flex>
      <Button
        data-testid={
          hasPurchases
            ? "create-new-instance-link"
            : "create-first-instance-link"
        }
        m={0}
        mt="xl"
        component={Link}
        href={persistUTMQueryParamsToString(router, "/account/new-instance")}
      >
        Create {hasPurchases ? "a new" : "your first"} instance
      </Button>
    </Card>
  );
}
